import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Размер страницы',
	PageOrientation: 'Ориентация страницы',
	Format: 'Формат',
	DPI: 'Разрешение (DPI)',
	Generate: 'Сгенерировать',
	LanguageName: 'русский',
	LanguageCode: 'ru'
};

export default translation;
